import { useState } from 'react';
import { supabase } from '../../lib/supabase';

export function SupportTicketModal({ onClose, initialSubject = '' }: { onClose: () => void; initialSubject?: string }) {
  const [subject, setSubject] = useState(initialSubject);
  const [question, setQuestion] = useState('');
  const [state, setState] = useState<'idle' | 'sending' | 'done' | 'error'>('idle');
  const [fout, setFout] = useState<string | null>(null);

  async function submit() {
    if (!question.trim() || state === 'sending') return;
    setFout(null);
    setState('sending');
    try {
      const token = (await supabase.auth.getSession()).data.session?.access_token;
      const res = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/support-ticket`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ subject, question }),
      });
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        setFout(res.status === 429 || res.status === 502 ? d?.error ?? null : null);
        throw new Error('status ' + res.status);
      }
      setFout(null);
      setState('done');
    } catch {
      setState('error');
    }
  }

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50" onClick={onClose}>
      <div className="bg-white rounded-2xl w-full max-w-md p-6 shadow-xl" onClick={(e) => e.stopPropagation()}>
        {state === 'done' ? (
          <>
            <div className="flex items-start justify-between mb-1">
              <h2 className="text-lg font-bold text-[#231F20]">Verstuurd</h2>
              <button onClick={onClose} className="text-gray-400 hover:text-gray-700 text-xl leading-none">&times;</button>
            </div>
            <p className="text-sm text-gray-600 mb-5">Bedankt voor je vraag. Ons team reageert per e-mail, meestal snel.</p>
            <div className="flex justify-end">
              <button onClick={onClose} className="bg-[#FF6B35] hover:bg-[#e85a20] text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors">Sluiten</button>
            </div>
          </>
        ) : (
          <>
            <div className="flex items-start justify-between mb-1">
              <h2 className="text-lg font-bold text-[#231F20]">Waar kunnen we je mee helpen?</h2>
              <button onClick={onClose} className="text-gray-400 hover:text-gray-700 text-xl leading-none">&times;</button>
            </div>
            <p className="text-sm text-gray-600 mb-4">Beschrijf je vraag of waar je vastloopt. Ons team reageert per e-mail.</p>
            <label className="block text-xs font-semibold text-gray-500 mb-1">Onderwerp</label>
            <input
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm mb-3 focus:outline-none focus:border-[#FF6B35]"
              placeholder="Bijv. Ik kom er niet uit met mijn mailinglijst"
            />
            <label className="block text-xs font-semibold text-gray-500 mb-1">Je vraag</label>
            <textarea
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              rows={4}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm mb-2 focus:outline-none focus:border-[#FF6B35]"
              placeholder="Vertel ons wat er speelt..."
            />
            {state === 'error' && <p className="text-sm text-red-600 mb-2">{fout ?? 'Versturen lukte niet. Mail je vraag naar support@dibbi.nl.'}</p>}
            <div className="flex items-center justify-end gap-2 mt-2">
              <button onClick={onClose} className="text-sm text-gray-600 px-3 py-2">Annuleren</button>
              <button
                onClick={submit}
                disabled={state === 'sending' || !question.trim()}
                className="bg-[#FF6B35] hover:bg-[#e85a20] disabled:opacity-50 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors"
              >
                {state === 'sending' ? 'Versturen...' : 'Verstuur'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
